import { render, staticRenderFns } from "./OscillographyAnalysisParametersTab.vue?vue&type=template&id=250b89fc&scoped=true&"
import script from "./OscillographyAnalysisParametersTab.vue?vue&type=script&lang=js&"
export * from "./OscillographyAnalysisParametersTab.vue?vue&type=script&lang=js&"
import style0 from "./OscillographyAnalysisParametersTab.vue?vue&type=style&index=0&id=250b89fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250b89fc",
  null
  
)

export default component.exports